import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Button, Image, Modal } from 'react-bootstrap';
import domainName from '../../domainName';
import { useSelector } from 'react-redux';
import { COLORS } from '../../colorTheme/colorTheme';
import ReactStarRatings from 'react-star-ratings';
import { useNavigate } from 'react-router-dom';
import { SHA256 } from 'crypto-js';
import { useTranslation } from "react-i18next";
import defaultProfileImage from '../../img/icons/no_image_1.png';
import CommentModal from "./CommentModal.jsx"
import EditPostModal from './EditPostModal.jsx';
import DeletePostModal from './DeletePostModal.jsx';

const MyProfile = () => {

    const { token, UserData, UserId } = useSelector((state) => state.login);
    const sentinelRef = useRef(null);
    const [initialFeedLoaded, setInitialFeedLoaded] = useState(false);

    const navigate = useNavigate();

    // user id which come from param
    const [targetUserId, setTargetUserId] = useState()

    // tab selection 
    const [tabFeed, setTabFeed] = useState(true);
    const [tabNew, setTabNew] = useState(false);
    const [tabReviews, setTabReviews] = useState(false);

    // data retrieve from API
    const [profileImageDisplay, setProfileImageDisplay] = useState();
    const [followers, setFollowers] = useState();
    const [following, setFollowing] = useState();
    const [reviews, setReviews] = useState();
    const [profileName, setProfileName] = useState();
    const [canFollow, setCanFollow] = useState();
    const [canFollowMa, setCanFollowMa] = useState();
    const [isFollow, setIsFollow] = useState();

    const [serviceLevel, setServiceLevel] = useState();
    const [UserAwards, setUserAwards] = useState();
    const [verified, setVerified] = useState();

    const [canWhatsapp, setCanWhatsApp] = useState();

    const [whatsappLink, setWhatsAppLink] = useState();
    const [serviceNameList, setServiceNameDisplayList] = useState([]);

    //posts and reviews
    const [postListing, setPostListing] = useState([])
    const [newListing, setNewListing] = useState([]);
    const [receivedReviewListing, setReceivedReviewListing] = useState([])

    const [t] = useTranslation("global");

    const [isExpanded, setIsExpanded] = useState(false);
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState(null);

    // for edit post modal
    const [showEditPostModal, setShowEditPostModal] = useState();
    const [editItem, setEditItem] = useState();

    //for delete post modal
    const [showDeletePostModal, setShowDeletePostModal] = useState(false)
    const [deleteItem, setDeleteItem] = useState()

    const [showCommentModal, setShowCommentModal] = useState(false);
    const [currentCommentPost, setCurrentCommentPost] = useState(null);

    const [feedPage, setFeedPage] = useState(1);
    const [feedHasMore, setFeedHasMore] = useState(true);

    const [newPage, setNewPage] = useState(1);
    const [newHasMore, setNewHasMore] = useState(true);

    const [reviewsPage, setReviewsPage] = useState(1);
    const [reviewsHasMore, setReviewsHasMore] = useState(true);

    const [isFetchingFeed, setIsFetchingFeed] = useState(false);
    const [isFetchingNew, setIsFetchingNew] = useState(false);
    const [isFetchingReviews, setIsFetchingReviews] = useState(false);

    const openMediaModal = (media) => {
        setSelectedMedia(media);
        setShowMediaModal(true);
    };

    const closeMediaModal = () => {
        setSelectedMedia(null);
        setShowMediaModal(false);
    };

    const [showLeavingModal, setShowLeavingModal] = useState(false);

    const handleLikeAction = async (item) => {
        const postId = item._id;
        const isNewTab = tabNew;

        if (isNewTab) {
            setNewListing((prev) =>
                prev.map((post) =>
                    post._id === postId
                        ? {
                            ...post,
                            isLike: !post.isLike,
                            likes: post.isLike ? post.likes - 1 : post.likes + 1,
                        }
                        : post
                )
            );
        } else {
            setPostListing((prev) =>
                prev.map((post) =>
                    post._id === postId
                        ? {
                            ...post,
                            isLike: !post.isLike,
                            likes: post.isLike ? post.likes - 1 : post.likes + 1,
                        }
                        : post
                )
            );
        }

        try {
            const response = await domainName.serverAPICall(
                domainName.debugAPI + "/community/userLikePost",
                "POST",
                JSON.stringify({
                    PostId: postId,
                    UserId: UserId,
                    PostUserId: item.author,
                })
            );

            const data = await domainName.handleServerAPICallErrors(response);

            if (data.ReturnCode !== 200) {
                if (isNewTab) {
                    setNewListing((prev) =>
                        prev.map((post) =>
                            post._id === postId
                                ? {
                                    ...post,
                                    isLike: !post.isLike,
                                    likes: post.isLike ? post.likes + 1 : post.likes - 1,
                                }
                                : post
                        )
                    );
                } else {
                    setPostListing((prev) =>
                        prev.map((post) =>
                            post._id === postId
                                ? {
                                    ...post,
                                    isLike: !post.isLike,
                                    likes: post.isLike ? post.likes + 1 : post.likes - 1,
                                }
                                : post
                        )
                    );
                }
            }
        } catch (error) {
            console.error("Error liking the post:", error);

            if (isNewTab) {
                setNewListing((prev) =>
                    prev.map((post) =>
                        post._id === postId
                            ? {
                                ...post,
                                isLike: !post.isLike,
                                likes: post.isLike ? post.likes + 1 : post.likes - 1,
                            }
                            : post
                    )
                );
            } else {
                setPostListing((prev) =>
                    prev.map((post) =>
                        post._id === postId
                            ? {
                                ...post,
                                isLike: !post.isLike,
                                likes: post.isLike ? post.likes + 1 : post.likes - 1,
                            }
                            : post
                    )
                );
            }
        }
    };

    const handleCommentAction = (item) => {
        setCurrentCommentPost(item);
        setShowCommentModal(true);
    };

    function LeavingAdviser2uModal({ show, onClose, onConfirm }) {
        return (
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("MyProfile.leavingAdviser2uTitle")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t("MyProfile.leavingAdviser2uMessage")}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        {t("MyProfile.Cancel")}
                    </Button>
                    <Button variant="primary" onClick={onConfirm}>
                        {t("MyProfile.proceed")}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    async function fetchCommunityPosts(targetUserId, page = 1) {
        setIsFetchingFeed(true);
        try {
            const response = await domainName.serverAPICall(
                domainName.debugAPI + "/user/userPostCommunityListing",
                "POST",
                JSON.stringify({
                    "targetUserId": targetUserId,
                    "ownUserId": UserId,
                    "PageNum": page,
                    "ResultNum": 10
                }),
            );
            const data = await domainName.handleServerAPICallErrors(response);
            const transformed = data.Data.map(post => ({
                ...post,
                isLike: post.IsLike,
                TotalLikes: post.likes,
                Totalcomments: post.comments,
                UserImageDisplay: post.UserImage,
                UserName: post.UserName || '',
                CreatedAtDisplay: post.DisplayCreatedAt,
            }));
            if (page === 1) {
                setPostListing(transformed);
            } else {
                setPostListing(prev => [...prev, ...transformed]);
            }

            if (transformed.length < 10) setFeedHasMore(false);
        } catch (err) {
            console.log("Fetch feed error:", err);
        } finally {
            setInitialFeedLoaded(true);
            setIsFetchingFeed(false);
        }
    }

    async function fetchCommunityNews(targetUserId, page = 1) {
        setIsFetchingNew(true);
        try {
            const response = await domainName.serverAPICall(
                domainName.debugAPI + "/user/userNewPostCommunityListing",
                "POST",
                JSON.stringify({
                    "targetUserId": targetUserId,
                    "ownUserId": UserId,
                    "PageNum": page,
                    "ResultNum": 10
                }),
            )

            const data = await domainName.handleServerAPICallErrors(response);
            const transformedData = data.Data.map(post => ({
                ...post,
                isLike: post.IsLike,
                TotalLikes: post.likes,
                Totalcomments: post.comments,
                UserImageDisplay: post.UserImage,
                UserName: post.UserName || '',
                CreatedAtDisplay: post.DisplayCreatedAt,
            }));

            if (page === 1) {
                setNewListing(transformedData);
            } else {
                setNewListing(prev => [...prev, ...transformedData]);
            }

            if (transformedData.length < 10) {
                setNewHasMore(false);
            }
        } catch (error) {
            console.log("/user/userNewPostCommunityListing error:", error);
        } finally {
            setInitialFeedLoaded(true);
            setIsFetchingNew(false);
        }
    }

    async function fetchReviewListing(targetUserId, page = 1) {
        setIsFetchingReviews(true);
        try {
            const response = await domainName.serverAPICall(
                domainName.debugAPI + "/user/userReceivedReviewListing",
                "POST",
                JSON.stringify({
                    "UserId": targetUserId,
                    //"ReviewerUserId": reviewUserId != undefined ? reviewUserId : null,
                    "ReviewerUserId": null,
                    "PageNum": page,
                    "ResultNum": 10
                }),
            );

            const data = await domainName.handleServerAPICallErrors(response);
            const newData = data.Data.ReceivedReviewListing || [];

            if (page === 1) {
                setReceivedReviewListing(newData);
            } else {
                setReceivedReviewListing(prev => [...prev, ...newData]);
            }

            if (newData.length < 10) {
                setReviewsHasMore(false);
            }
        } catch (error) {
            console.log("/user/userReceivedReviewListing error:", error);
        } finally {
            setInitialFeedLoaded(true);
            setIsFetchingReviews(false);
        }
    }

    async function unfollow() {
        await domainName
            .serverAPICall(
                domainName.debugAPI + "/user/userUnFollowing",
                "POST",
                JSON.stringify({
                    "UserId": UserId,
                    "TargetUserId": targetUserId
                }),
            )
            .then(domainName.handleServerAPICallErrors)
            .then((responseJson => {
                //console.log('/user/userUnFollowing : response : ', responseJson)
                if (responseJson.ReturnCode == 200) {
                    setCanFollowMa(true)
                    setFollowers(prevState => prevState - 1);
                }
            }))
            .catch((error) => {
                //console.log('/user/userUnFollowing : error : ', error)
            });
    }

    async function follow() {
        await domainName
            .serverAPICall(
                domainName.debugAPI + "/user/userFollowing",
                "POST",
                JSON.stringify({
                    "UserId": UserId,
                    "TargetUserId": targetUserId
                }),
            )
            .then(domainName.handleServerAPICallErrors)
            .then((responseJson => {
                //console.log('/user/userFollowing : response : ', responseJson)
                //setCanFollowMa
                if (responseJson.ReturnCode == 200) {
                    setCanFollowMa(false)
                    setFollowers(prevState => prevState + 1);
                }
            }))
            .catch((error) => {
                //console.log('/user/userFollowing : error : ', error)
            });
    }



    async function getUserInfo(otherUserId) {
        await domainName
            .serverAPICall(
                domainName.debugAPI + "/user/selectUserInfoById",
                "POST",
                JSON.stringify({
                    "UserId": UserId,
                    "TargetUserId": otherUserId != undefined ? otherUserId : UserId
                })
            )
            .then(domainName.handleServerAPICallErrors)
            .then((responseJson => {
                // console.log('/user/selectUserInfoById responseJson here', responseJson)
                setProfileImageDisplay(responseJson.Data.UserImage)
                setFollowers(responseJson.Data.TotalFollower)
                setFollowing(responseJson.Data.TotalFollowing)
                setReviews(responseJson.Data.UserReviewListCount)
                setUserAwards(responseJson.Data.UserAwards)
                setVerified(responseJson.Data.IsVerify)
                setProfileName(responseJson.Data.UserName)
                setCanFollow(responseJson.Data.CanFollow)
                setCanFollowMa(responseJson.Data.CanFollow)
                setIsFollow(responseJson.Data.IsFollow)
                setCanWhatsApp(responseJson.Data.CanWhatsappsUser)
                // if (responseJson.Data.CanWhatsappsUser) {
                //     setWhatsAppLink(responseJson.Data.WhatappsUser)
                // }
                setWhatsAppLink(responseJson.Data.WhatappsLink)
                setServiceNameDisplayList(responseJson.Data.ServiceNameDisplayList)
                setServiceLevel(responseJson.Data.ServiceLevel)
            }))
            .catch((error) => {
                //console.log('/user/selectUserInfoById error here', error)
            });
    }

    function renderReviewCard(reviewitem) {
        return (
            <div style={{
                borderBottom: '0.5px solid ' + COLORS.lightGray1,
                paddingBottom: '20px',
                marginTop: '20px'
            }}>
                {/* Row 1: Avatar + Name + Star (middle) + Date (right) */}
                <Row className="align-items-center">
                    <Col xs={2} md={1} className="text-center">
                        <Image
                            src={reviewitem.ReviewerImage || defaultProfileImage}
                            width={50}
                            height={50}
                            style={{ borderRadius: 50, objectFit: 'cover' }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = defaultProfileImage;
                            }}
                        />
                    </Col>
                    <Col xs={7} md={8}>
                        <div
                            style={{ fontWeight: 'bold', color: COLORS.black, cursor: 'pointer' }}
                            onClick={() => {
                                navigate(`/myProfile?userId=${reviewitem.ReviewerUserId}`);
                                window.location.reload();
                            }}
                        >
                            {reviewitem.ReviewerName}
                        </div>
                        <ReactStarRatings
                            rating={reviewitem.Likes}
                            starRatedColor={COLORS.orange}
                            numberOfStars={5}
                            starDimension="18px"
                            starSpacing="1px"
                        />
                    </Col>
                    <Col xs={3} md={3} className="text-end">
                        <span style={{ color: COLORS.gray }}>{reviewitem.CreatedTimestampDisplay}</span>
                    </Col>
                </Row>

                {/* Row 2: Review Message */}
                {reviewitem.ReviewMessage && (
                    <Row className="mt-3">
                        <Col>
                            <span style={{ color: COLORS.darkGray, whiteSpace: 'pre-wrap' }}>
                                {reviewitem.ReviewMessage}
                            </span>
                        </Col>
                    </Row>
                )}

                {/* Row 3: Image(s) if available */}
                {reviewitem.DisplayAttachmentPhoto && reviewitem.DisplayAttachmentPhoto.length > 0 && (
                    <Row className="mt-2">
                        <Col>
                            <div className="d-flex flex-wrap">
                                {reviewitem.DisplayAttachmentPhoto.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        alt={`review-${index}`}
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                            objectFit: 'cover',
                                            borderRadius: '10px',
                                            marginRight: '10px',
                                            marginBottom: '10px',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => openMediaModal(img)}
                                    />
                                ))}
                            </div>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }

    function renderCard(item) {
        const handleToggleExpand = () => {
            setIsExpanded(prev => !prev);
        };

        return (
            <div style={{
                borderBottom: '0.5px solid ' + COLORS.lightGray1,
                paddingBottom: '20px',
                marginTop: '20px'
            }}>
                {/* User Info */}
                <div className="d-flex align-items-center mb-2">
                    <img
                        src={item.UserImage || defaultProfileImage}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = defaultProfileImage;
                        }}
                        style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            marginRight: '10px'
                        }}
                    />
                    <div>
                        <div style={{ fontWeight: 'bold', color: COLORS.black }}>
                            {item.UserName}
                        </div>
                        <div style={{ color: COLORS.gray }}>
                            {item.DisplayCreatedAt}
                        </div>
                    </div>
                </div>

                {/* Post Title / Content */}
                <div style={{ color: COLORS.darkGray, whiteSpace: 'pre-wrap' }}>
                    {isExpanded || item.title.length <= 100
                        ? item.title
                        : item.title.slice(0, 100) + '...'}
                </div>

                {/* See More */}
                {item.title.length > 100 && (
                    <div
                        style={{ color: COLORS.orange, cursor: 'pointer', marginTop: '5px' }}
                        onClick={handleToggleExpand}
                    >
                        {isExpanded ? t('MyProfile.seeLess') : t('MyProfile.seeMore')}
                    </div>
                )}

                {/* Image List */}
                {item.ListingImageDisplay && item.ListingImageDisplay.length > 0 && (
                    <div className="d-flex flex-row flex-wrap mt-3">
                        {item.ListingImageDisplay.map((imgUrl, idx) => (
                            <img
                                key={idx}
                                src={imgUrl}
                                onClick={() => openMediaModal(imgUrl)}
                                style={{
                                    width: '150px',
                                    height: '150px',
                                    objectFit: 'cover',
                                    borderRadius: '10px',
                                    marginRight: '10px',
                                    marginBottom: '10px',
                                    cursor: 'pointer'
                                }}
                            />
                        ))}
                    </div>
                )}

                {/* Like / Comment */}
                <div className="d-flex align-items-center mt-3 gap-3">
                    <div className="d-flex align-items-center" onClick={() => handleLikeAction(item)}>
                        <img
                            src={item.isLike
                                ? require('../../img/icons/liked.png')
                                : require('../../img/icons/like.png')}
                            style={{ width: '22px', height: '22px', cursor: 'pointer' }}
                            alt="like"
                        />
                        <span className="ms-1">{item.likes}</span>
                    </div>

                    <div className="d-flex align-items-center" onClick={() => handleCommentAction(item)}>
                        <img
                            src={require('../../img/icons/comments.png')}
                            style={{ width: '22px', height: '22px', cursor: 'pointer' }}
                            alt="comments"
                        />
                        <span className="ms-1">{item.comments || 0}</span>
                    </div>
                </div>
            </div>
        );
    }

    function renderTabContent() {
        return (
            <div style={{ marginTop: '5%' }}>
                {tabFeed && (
                    postListing.length >= 1 ? (
                        postListing.map((item, index) => renderCard(item))
                    ) : (
                        <div style={{ backgroundColor: COLORS.lightGray4, textAlign: 'center', marginTop: '2%' }}>
                            <div style={{ paddingTop: '3%' }}>
                                <img
                                    src={require("../../img/icons/description.png")}
                                    alt="My Post Icon"
                                    style={{ mixBlendMode: 'multiply', width: '80px', height: 'auto' }}
                                />
                            </div>
                            <div style={{ paddingTop: '2%', paddingBottom: '3%', color: COLORS.black }}>
                                {t("MyProfile.Don't have any posts yet")}
                            </div>
                        </div>
                    )
                )}

                {tabNew && (
                    newListing.length >= 1 ? (
                        newListing.map((item, index) => renderCard(item))
                    ) : (
                        <div style={{ backgroundColor: COLORS.lightGray4, textAlign: 'center', marginTop: '2%' }}>
                            <div style={{ paddingTop: '3%' }}>
                                <img
                                    src={require("../../img/icons/description.png")}
                                    alt="New Icon"
                                    style={{ mixBlendMode: 'multiply', width: '80px', height: 'auto' }}
                                />
                            </div>
                            <div style={{ paddingTop: '2%', paddingBottom: '3%', color: COLORS.black }}>
                                {t("MyProfile.Don't have any new items yet")}
                            </div>
                        </div>
                    )
                )}

                {tabReviews && (
                    receivedReviewListing && receivedReviewListing.length > 0 ? (
                        receivedReviewListing.map((item, index) => renderReviewCard(item))
                    ) : (
                        <div style={{ backgroundColor: COLORS.lightGray4, textAlign: 'center', marginTop: '2%' }}>
                            <div style={{ paddingTop: '3%' }}>
                                <img
                                    src={require("../../img/icons/myreview.png")}
                                    alt="My Review Icon"
                                    style={{ mixBlendMode: 'multiply', width: '80px', height: 'auto' }}
                                />
                            </div>
                            <div style={{ paddingTop: '2%', paddingBottom: '3%', color: COLORS.black }}>
                                {t("MyProfile.Don't have any reviews yet")}
                            </div>
                        </div>
                    )
                )}
            </div>
        );
    }

    function renderTabSelection() {
        return (
            <Row className='mt-3'>
                <Col xs={4} md={4} lg={3} className="d-flex">
                    <button type="button" class="input-group btn" style={{
                        backgroundColor: COLORS.white,
                        color: tabFeed ? COLORS.orange : COLORS.black,
                        borderBottomWidth: tabFeed ? 1 : 0,
                        borderBottomColor: COLORS.orange,
                        borderRadius: 0
                    }}
                        onClick={() => {
                            const userIdToUse = targetUserId || UserId;
                            setTabFeed(true);
                            setTabNew(false);
                            setTabReviews(false);
                            setFeedPage(1);
                            setFeedHasMore(true);
                            setIsFetchingFeed(false);       
                            setInitialFeedLoaded(false); 
                            setPostListing([]);
                            fetchCommunityPosts(userIdToUse, 1);
                        }}>
                        {t("MyProfile.Feed")}
                    </button>
                </Col>
                <Col xs={4} md={4} lg={3} className="d-flex">
                    <button type="button" class="input-group btn" style={{
                        backgroundColor: COLORS.white,
                        color: tabNew ? COLORS.orange : COLORS.black,
                        borderBottomWidth: tabNew ? 1 : 0,
                        borderBottomColor: COLORS.orange,
                        borderRadius: 0
                    }}
                        onClick={() => {
                            const userIdToUse = targetUserId || UserId;
                            setTabFeed(false);
                            setTabNew(true);
                            setTabReviews(false);
                            setNewPage(1);
                            setNewHasMore(true);
                            setIsFetchingNew(false);
                            setInitialFeedLoaded(false);
                            setNewListing([]);
                            fetchCommunityNews(userIdToUse, 1);
                        }}>
                        {t("MyProfile.New")}
                    </button>
                </Col>
                <Col xs={4} md={4} lg={3} className="d-flex">
                    <button type="button" class="input-group btn" style={{
                        backgroundColor: COLORS.white,
                        color: tabReviews ? COLORS.orange : COLORS.black,
                        borderBottomWidth: tabReviews ? 1 : 0,
                        borderBottomColor: COLORS.orange,
                        borderRadius: 0
                    }}
                        onClick={() => {
                            const userIdToUse = targetUserId || UserId;
                            setTabFeed(false);
                            setTabNew(false);
                            setTabReviews(true);
                            setReviewsPage(1);
                            setReviewsHasMore(true);
                            setIsFetchingReviews(false);
                            setInitialFeedLoaded(false); 
                            setReceivedReviewListing([]);
                            fetchReviewListing(userIdToUse, 1);
                        }}>
                        {t("MyProfile.Reviews")}
                    </button>
                </Col>
            </Row>
        )
    }

    function greyLine() {
        return (
            <div
                style={{
                    borderBottom: '1px solid black',
                    borderColor: '#D9D9D9',
                    // margin: '10px 0',
                }}
            ></div>
        )
    }

    function renderFollowChatButton() {
        // console.log("whatsappLink =>", whatsappLink);
        return (
            <Row className="mt-2">
                {
                    targetUserId &&
                    <Col xs={5} md={3} lg={4} className="d-flex justify-content-center">
                        <button type="button" class="input-group btn  w-100" style={{ backgroundColor: canFollowMa ? COLORS.orange : COLORS.lightGray2, color: canFollowMa ? COLORS.white : COLORS.black }} onClick={() => {
                            if (canFollowMa) {
                                follow()
                            } else {
                                unfollow()
                            }
                        }}>
                            {canFollowMa ? t("MyProfile.Follow") : t("MyProfile.Following")}
                        </button>
                    </Col>
                }

                {
                    targetUserId &&
                    <Col xs={5} md={3} lg={4} className="d-flex justify-content-center">
                        <button type="button" class="input-group btn  w-100" style={{ backgroundColor: COLORS.lightGray1, color: COLORS.black }} onClick={async () => {
                            let currentTime = new Date().getTime(); //epoch timestamp now
                            const resultEncrypted = SHA256(UserId + process.env.REACT_APP_COMMUNITY_APP_KEY + "Adviser2u" + currentTime)
                            navigate(`/message?userId=${UserId}&messageId=${targetUserId}&uid=${resultEncrypted}&tid=${currentTime}`)
                        }}>
                            {t("MyProfile.Chat")}
                        </button>
                    </Col>
                }
                {canWhatsapp && targetUserId && whatsappLink && (
                    <Col xs={2} md={3} lg={2} className="d-flex justify-content-start">
                        <button
                            className="btn"
                            style={{
                                backgroundColor: COLORS.lightGray2,
                                width: '38px',
                                height: '38px',
                                borderRadius: '8px',
                                border: 'none',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                            onClick={() => setShowLeavingModal(true)}
                        >
                            <img
                                src={require("../../img/icons/whatsapp.png")}
                                alt="WhatsApp"
                                style={{ width: '18px', height: '18px' }}
                            />
                        </button>
                    </Col>
                )}
            </Row>
        )
    }

    function renderNameAndInfo() {
        return (
            <div>
                <Row className="mt-2">

                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                        {
                            serviceLevel &&
                            <div style={{ marginRight: '2.5%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Image src={require("../../img/icons/premier.png")} width={22} height={22} style={{ marginRight: '5%' }} />
                                    <span style={{ fontSize: 17 }}>{serviceLevel}</span>
                                </div>
                            </div>
                        }

                        {
                            verified &&
                            <div style={{ marginRight: '2.5%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Image src={require("../../img/icons/verified2.png")} width={22} height={22} style={{ marginRight: '5%' }} />
                                    <span>{verified}</span>
                                </div>
                            </div>
                        }

                        {
                            UserAwards &&
                            <div style={{ marginRight: '2.5%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Image src={require("../../img/icons/gold.png")} width={22} height={22} style={{ marginRight: '5%' }} />
                                    <span>{UserAwards}</span>
                                </div>
                            </div>
                        }

                    </div>
                </Row>
            </div>

        )
    }

    function renderTopHeader() {
        return (
            <Row className="mt-2 align-items-center">
                <Col xs={12} md={3} lg={2} className="text-center">
                    <img
                        src={profileImageDisplay || defaultProfileImage}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = defaultProfileImage;
                        }}
                        style={{
                            width: '100px',
                            height: '100px',
                            borderRadius: 100,
                            objectFit: 'cover',
                        }}
                    />
                </Col>

                <Col xs={12} md={9} lg={10}>
                    {/* Name (center on mobile, left on desktop) */}
                    <div className="text-center text-md-start mb-2 mt-2">
                        <h4 className="mb-0">{profileName}</h4>
                    </div>

                    {/* Follower / Following / Reviews */}
                    <Row className="text-md-start">
                        <Col xs={4} md={3} lg={2}>
                            <div style={{ paddingLeft: '1.8em' }}>{followers}</div>
                            <div>{t("MyProfile.Followers")}</div>
                        </Col>
                        <Col xs={4} md={3} lg={2}>
                            <div style={{ paddingLeft: '1.8em' }}>{following}</div>
                            <div>{t("MyProfile.Following")}</div>
                        </Col>
                        <Col xs={4} md={3} lg={2}>
                            <div style={{ paddingLeft: '1.4em' }}>{reviews}</div>
                            <div>{t("MyProfile.Reviews")}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }


    async function editCommunityNews(postsid, imagePassedIn, messageText) {

        await domainName
            .serverAPICall(
                domainName.debugAPI + "/community/editCommunityNews",
                "POST",
                JSON.stringify({
                    "PostsId": postsid,
                    "Type": "POST",
                    "Voting": [
                        {
                            "title": "option 1",
                            "userIdList": []
                        },
                        {
                            "title": "option 2",
                            "userIdList": []
                        },
                        {
                            "title": "option 3",
                            "userIdList": []
                        }
                    ],
                    "Title": messageText,
                    "Photos": imagePassedIn ? imagePassedIn : []
                })
            )
            .then(domainName.handleServerAPICallErrors)
            .then((async responseJson => {
                //console.log(`/community/editCommunityNews responseJson here`, responseJson)
                if (responseJson.ReturnCode == 200) {
                    setShowEditPostModal(false)
                    window.location.reload();
                } else {
                    alert(`${t("error.Cannot edit")} ${tabFeed ? t('community.Feed') : t('community.News')} ${("error.post. Please try it again later.")}`)
                }
            }))
            .catch((error) => {
                //console.log(`/community/editCommunityNews error here`, error)
            });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        const searchParams = new URLSearchParams(window.location.search);
        const userId = searchParams.get('userId');
        const tabParam = searchParams.get('tab');

        const userIdToUse = userId || UserId;
        if (userId !== UserId) setTargetUserId(userId);
        setInitialFeedLoaded(false);
        getUserInfo(userIdToUse);

        getUserInfo(userId);

        if (tabParam === 'reviews') {
            setTabFeed(false); setTabNew(false); setTabReviews(true);
            setReviewsPage(1); setReviewsHasMore(true);
            fetchReviewListing(userIdToUse, 1);
        } else if (tabParam === 'new') {
            setTabFeed(false); setTabNew(true); setTabReviews(false);
            setNewPage(1); setNewHasMore(true);
            fetchCommunityNews(userIdToUse, 1);
        } else {
            setTabFeed(true); setTabNew(false); setTabReviews(false);
            setFeedPage(1); setFeedHasMore(true);
            fetchCommunityPosts(userIdToUse, 1);
        }
    }, []);

    useEffect(() => {
        const userIdToUse = targetUserId || UserId;
        if (!userIdToUse || !initialFeedLoaded) return;

        if (tabFeed) fetchCommunityPosts(userIdToUse, feedPage);
        if (tabNew) fetchCommunityNews(userIdToUse, newPage);
        if (tabReviews) fetchReviewListing(userIdToUse, reviewsPage);
    }, [feedPage, newPage, reviewsPage]);

    useEffect(() => {
        if (!targetUserId && !UserId) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const target = entries[0];
                if (target.isIntersecting) {
                    if (tabFeed && feedHasMore && !isFetchingFeed) setFeedPage((prev) => prev + 1);
                    if (tabNew && newHasMore && !isFetchingNew) setNewPage((prev) => prev + 1);
                    if (tabReviews && reviewsHasMore && !isFetchingReviews) setReviewsPage((prev) => prev + 1);
                }
            },
            { root: null, rootMargin: '0px', threshold: 0.1 }
        );

        const timeout = setTimeout(() => {
            const sentinel = sentinelRef.current;
            if (sentinel) observer.observe(sentinel);
        }, 100);

        return () => {
            clearTimeout(timeout);
            const sentinel = sentinelRef.current;
            if (sentinel) observer.unobserve(sentinel);
        };
    }, [tabFeed, tabNew, tabReviews, feedHasMore, newHasMore, reviewsHasMore, targetUserId, UserId, initialFeedLoaded]);

    return (
        <div className="greybk-div p-lg-5" style={{
            minHeight: "90vh",
            height: 'auto',
        }}>
            <Container>
                <Row className="justify-content-center align-items-center" >
                    <Col className="col-lg-12" >
                        <Container className="box-container p-5" style={{ height: 'auto' }}>

                            {renderTopHeader()}
                            {renderNameAndInfo()}
                            {renderFollowChatButton()}

                            {/* My Profile */}
                            <Row className='mt-3'>
                                <Col>
                                    <h4 className="fw-bold">{t("MyProfile.My Insights")}</h4>
                                </Col>
                            </Row>

                            <Row className='mt-2'>
                                {greyLine()}
                            </Row>
                            {renderTabSelection()}
                            {renderTabContent()}

                            {showCommentModal && currentCommentPost && (
                                <CommentModal
                                    post={currentCommentPost}
                                    onClose={() => setShowCommentModal(false)}
                                    userId={UserId}
                                    isOwner={currentCommentPost?.author === UserId}
                                    onEdit={() => {
                                        setShowCommentModal(false);
                                        setEditItem(currentCommentPost);
                                        setShowEditPostModal(true);
                                    }}
                                    onDelete={() => {
                                        setShowCommentModal(false);
                                        setDeleteItem(currentCommentPost);
                                        setShowDeletePostModal(true);
                                    }}
                                    onLike={handleLikeAction}
                                    onCommentAdded={() => {
                                        const isNewTab = tabNew;
                                        const targetList = isNewTab ? newListing : postListing;
                                        const updateList = targetList.map((post) =>
                                            post._id === currentCommentPost._id
                                                ? { ...post, comments: (post.comments || 0) + 1 }
                                                : post
                                        );
                                        if (isNewTab) setNewListing(updateList);
                                        else setPostListing(updateList);
                                    }}
                                />
                            )}
                            <EditPostModal
                                show={showEditPostModal}
                                onClose={() => setShowEditPostModal(false)}
                                editItem={editItem}
                                isFeed={tabFeed} // or tabNew depending on your API
                                t={t}
                                editCommunityNews={editCommunityNews}
                            />

                            <DeletePostModal
                                show={showDeletePostModal}
                                onClose={() => setShowDeletePostModal(false)}
                                deleteItem={deleteItem}
                                t={t}
                            />

                            <LeavingAdviser2uModal
                                show={showLeavingModal}
                                onClose={() => setShowLeavingModal(false)}
                                onConfirm={() => {
                                    setShowLeavingModal(false);
                                    window.open(whatsappLink, '_blank');
                                }}
                            />

                            {/* Fullscreen Image Modal */}
                            <Modal
                                show={showMediaModal}
                                onHide={closeMediaModal}
                                centered
                            >
                                <Modal.Body
                                    style={{
                                        padding: 0,
                                        backgroundColor: 'black',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    {selectedMedia && (
                                        selectedMedia.endsWith('.mp4') || selectedMedia.endsWith('.quicktime') || selectedMedia.endsWith('.MOV') ? (
                                            <video
                                                controls
                                                src={selectedMedia}
                                                style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                                            />
                                        ) : (
                                            <img
                                                src={selectedMedia}
                                                alt="Media"
                                                style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                                            />
                                        )
                                    )}
                                </Modal.Body>
                            </Modal>
                        </Container>
                    </Col>
                </Row>
            </Container>

            <div id="scroll-sentinel" ref={sentinelRef} style={{ height: '1px' }}></div>
        </div>
    )
}

export default MyProfile